import BaseModel from "../core/BaseModel";
export default class SituationModel extends BaseModel {
  constructor() {
    super(
      {
        name: "situation",
        tableName: "situation",
        label: "Danh Sách Tình Huống Công Việc",
        display_key: "name",
        default_order: { key: "created_at", direction: "asc" },
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: { 
            name: 'id', 
            type: "Uuid", 
            label: 'ID', 
            primaryKey: true,
            display: false
        },
        department: {
          name: "department",
          label: "Bộ phận",
          type: "MultiSelect",
          filter: {
            type: "SelectScroll",
            optionLabel: "name",
            optionKey: "id",
            match: "equals",
          },
        },
        // name_department: {
        //   name: 'name_department',
        //   type: "TEXT",
        //   label: 'Bộ phận',
        //   sortable: false,
        //   // width: 20,
        //   filter: {type: 'input',match: 'contains'}
        // },
        name_work: {
          name: 'name_work',
          type: "TEXT",
          label: 'Công việc',
          sortable: false,
          // width: 20,
          filter: {type: 'input',match: 'contains'}
        },
        name: {
            name: 'name',
            type: "TEXT",
            label: 'Tình huống',
            sortable: false,
            // width: 20,
            filter: {type: 'input',match: 'contains'}
        },
        created_name : {
            name: 'created_name', 
            type: "TEXT", 
            label: 'Người tạo',
        },
        created_at : {
            name: 'created_at', 
            type: "Datetime", 
            label: 'Ngày tạo',
        },
        updated_name : {
          name: 'updated_name', 
          type: "TEXT", 
          label: 'Người cập nhật',
        },
        status: {
          name: "status",
          label: "Trạng thái",
          type: "Selection",
          custom: 'SelectionText',
          class: "center",
          options: [
            { value: "APPROVED", label: "Đã duyệt" },
            { value: "WAITTING", label: "Chưa duyệt" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        active: {
          name: "active",
          label: "Hiển thị",
          type: "Selection",
          custom: "SelectionText",
          class: "center",
          options: [
            { value: true, label: "Có" },
            { value: false, label: "Không" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        }
      }
    );
  }
}
